import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CFormLabel, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CFormInput } from '@coreui/react'
import { Plus } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import CustomDatePickingFormat from '../../../src/components/shared/CustomDatePickingFormat'

const SelfCareAssessment = ({ diagnosisName, noteStructureRef, showDataIfNoteIsFollowUp = false, showTreatmentAsAccordion }) => {
  // console.log(showDataIfNoteIsFollowUp, 'showDataIfNoteIsFollowUp in self care assessment')
  const [visible, setVisible] = useState(false)
  const today = new Date()
  const formattedDate = `${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}/${today.getFullYear()}`

  const [selfCareValues, setSelfCareValues] = useState({
    date: formattedDate,
    Eating: [],
    'Oral hygiene': [],
    'Toileting hygiene': [],
    'Shower or bath': [],
    'Upper body dressing': [],
    'Lower body dressing': [],
    'Putting on or taking off footwear': [],
    'VISION/HEARING: MDS B (hearing, speech, vision)': {
      date: formattedDate,
      'Hearing Aid': '',
      Vision: [],
    },
    'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)': {
      date: formattedDate,
      Diet: [],
      Fluid: '',
      'Swallowing Issues': [],
      'Bowel Continence': [],
      'Bladder Continence': [],
    },
    'Foundation Goals': {
      date: formattedDate,
      'Patient meeting hydration goals': '',
      'Patient meeting nutritional goals': '',
      'Patient has 7-8 hours of uniterupted sleep?': '',
      'Active Therapy': [],
    },
  })

  useEffect(() => {
    if (noteStructureRef?.current?.selfCareAssessment && noteStructureRef.current.selfCareAssessment[diagnosisName]) {
      setSelfCareValues(noteStructureRef.current.selfCareAssessment[diagnosisName])
    }
  }, [diagnosisName, noteStructureRef])

  const handleChange = (key, value, section = null) => {
    if (section) {
      setSelfCareValues((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [key]: value,
        },
      }))
    } else {
      setSelfCareValues((prev) => ({
        ...prev,
        [key]: value,
      }))
    }
  }

  const activityOptions = {
    Eating: 'Eating',
    'Oral hygiene': 'Oral hygiene',
    'Toileting hygiene': 'Toileting hygiene',
    'Shower or bath': 'Shower or bath',
    'Upper body dressing': 'Upper body dressing',
    'Lower body dressing': 'Lower body dressing',
    'Putting on or taking off footwear': 'Putting on or taking off footwear',
  }

  const sharedOptions = ['Independent', 'Set up or cleanup assistance', 'Supervision or touching assistant', 'Partial moderate assistant', 'Substantial maximal assistant', 'Dependent', 'Patient refused']

  const getSingleSelectValue = (value) => {
    const selectedValue = Array.isArray(value) ? value[0] : value

    if (selectedValue === null || selectedValue === undefined) return null
    if (typeof selectedValue === 'string' && selectedValue.trim() === '') return null

    return { value: selectedValue, label: selectedValue }
  }

  const selfCareSelectProps = {
    className: 'ui-react-select basic-single-select',
    classNamePrefix: 'select',
    menuPlacement: 'auto',
    menuShouldScrollIntoView: false,
    maxMenuHeight: 220,
  }

  const handleSave = () => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      selfCareAssessment: {
        [diagnosisName]: selfCareValues,
      },
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          selfCareAssessment: selfCareValues,
        },
      },
    }
    setVisible(false)
    console.log(noteStructureRef)
  }

  // const renderValue = (value, key) => {
  //     if (Array.isArray(value)) {
  //         return value.join(', ');
  //     } else if (typeof value === 'string') {
  //         return key === 'date' ? value : value;
  //     } else if (typeof value === 'object' && value !== null) {
  //         return (
  //             <div className="d-flex flex-column ">
  //                 {
  //                     Object.entries(value).map(([childKey, childValue], idx) => (
  //                         <div key={idx} className="d-flex gap-2">
  //                             <b style={{textTransform:"capitalize"}}>{childKey}:</b>
  //                             <span>{renderValue(childValue, childKey)}</span>
  //                         </div>
  //                     ))
  //                 }
  //             </div>
  //         );
  //     } else {
  //         return '';
  //     }
  // };

  // const renderValue = (value, key) => {
  //     if (!value || (Array.isArray(value) && value.length === 0)) {
  //         return null;
  //     }

  //     if (Array.isArray(value)) {
  //         return value.join(', ');
  //     } else if (typeof value === 'string') {
  //         if (key.toLowerCase().includes('date') && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
  //             const [month, day, year] = value.split('-');
  //             return `${month}/${day}/${year}`;
  //         }
  //         return value;
  //     } else if (typeof value === 'object' && value !== null) {
  //         const entries = Object.entries(value).filter(
  //             ([_, childValue]) =>
  //                 childValue &&
  //                 !(Array.isArray(childValue) && childValue.length === 0) &&
  //                 !(typeof childValue === 'string' && childValue.trim() === '')
  //         );

  //         if (entries.length === 0) return null;

  //         return (
  //             <div className="d-flex flex-column">
  //                 {entries.map(([childKey, childValue], idx) => (
  //                     <div key={idx} className="d-flex gap-2">
  //                         <b style={{ textTransform: "capitalize" }}>{childKey}:</b>
  //                         <span>{renderValue(childValue, childKey)}</span>
  //                     </div>
  //                 ))}
  //             </div>
  //         );
  //     }

  //     return '';
  // };

  // const renderValue = (value, key) => {
  //     if (!value || (Array.isArray(value) && value.length === 0)) {
  //         return null;
  //     }

  //     if (Array.isArray(value)) {
  //         return value.join(', ');
  //     } else if (typeof value === 'string') {
  //         // skip blank strings
  //         if (value.trim() === '') return null;

  //         // Format valid MM-DD-YYYY to MM/DD/YYYY
  //         if (key.toLowerCase().includes('date') && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
  //             const [month, day, year] = value.split('-');
  //             return `${month}/${day}/${year}`;
  //         }

  //         return value;
  //     } else if (typeof value === 'object' && value !== null) {
  //         const entries = Object.entries(value).filter(
  //             ([childKey, childValue]) => {
  //                 const isEmpty =
  //                     !childValue ||
  //                     (Array.isArray(childValue) && childValue.length === 0) ||
  //                     (typeof childValue === 'string' && childValue.trim() === '');

  //                 // Skip if only a date and no meaningful data
  //                 const isJustDate = childKey.toLowerCase().includes('date');
  //                 return !isEmpty && !isJustDate;
  //             }
  //         );

  //         if (entries.length === 0) return null;

  //         return (
  //             <div className="d-flex flex-column">
  //                 {entries.map(([childKey, childValue], idx) => {
  //                     const rendered = renderValue(childValue, childKey);
  //                     if (!rendered) return null;
  //                     return (
  //                         <div key={idx} className="d-flex gap-2">
  //                             <b style={{ textTransform: "capitalize" }}>{childKey}:</b>
  //                             <span>{rendered}</span>
  //                         </div>
  //                     );
  //                 })}
  //             </div>
  //         );
  //     }

  //     return '';
  // };

  const renderValue = (value, key) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return null
    }

    if (Array.isArray(value)) {
      return value.join(', ')
    } else if (typeof value === 'string') {
      if (value.trim() === '') return null

      // Format date if it looks like MM-DD-YYYY or MM/DD/YYYY
      if (key.toLowerCase().includes('date')) {
        const dateParts = value.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/)
        if (dateParts) {
          const [_, month, day, year] = dateParts
          return `${month}/${day}/${year}`
        }
      }

      return value
    } else if (typeof value === 'object' && value !== null) {
      const entries = Object.entries(value).filter(([childKey, childValue]) => {
        const isEmpty = !childValue || (Array.isArray(childValue) && childValue.length === 0) || (typeof childValue === 'string' && childValue.trim() === '')
        return !isEmpty
      })

      if (entries.length === 0) return null

      return (
        <div className="d-flex flex-column">
          {entries.map(([childKey, childValue], idx) => {
            const rendered = renderValue(childValue, childKey)
            if (!rendered) return null
            return (
              <div key={idx} className="d-flex gap-2">
                <b style={{ textTransform: 'capitalize' }}>{childKey}:</b>
                <span>{rendered}</span>
              </div>
            )
          })}
        </div>
      )
    }

    return ''
  }

  return (
    <>
      {showTreatmentAsAccordion ? (
        <div flush>
          <div>
            <div>
              <span className="d-flex align-items-center gap-2">
                <h7>
                  <b>Self Care Assessment</b>
                </h7>
              </span>
              <hr />
            </div>
            <div>
              <div>
                {
                  <div className="d-flex flex-column px-2 ">
                    {noteStructureRef.current &&
                      noteStructureRef.current.selfCareAssessment &&
                      noteStructureRef.current.selfCareAssessment[diagnosisName] &&
                      Object.entries(noteStructureRef.current.selfCareAssessment[diagnosisName])
                        .filter(([_, value]) => {
                          if (value === null || value === undefined) return false
                          if (typeof value === 'string') return value.trim() !== ''
                          if (Array.isArray(value)) return value.length > 0
                          if (typeof value === 'object') {
                            const entries = Object.entries(value).filter(([_, v]) => v && (!Array.isArray(v) || v.length > 0) && (typeof v !== 'string' || v.trim() !== ''))
                            return entries.length > 0
                          }
                          return true
                        })
                        .map(([key, value], idx) => (
                          <div key={idx} className="d-flex flex-column mb-2">
                            {typeof value === 'object' && value !== null && !Array.isArray(value) ? (
                              (() => {
                                const rendered = renderValue(value, key)
                                return rendered ? (
                                  <>
                                    <b>{key}</b>
                                    <div>{rendered}</div>
                                  </>
                                ) : null
                              })()
                            ) : (
                              <div className="d-flex gap-2">
                                <b style={{ textTransform: 'capitalize' }}>{key}:</b>
                                <span>{Array.isArray(value) ? value.join(', ') : renderValue(value, key)}</span>
                              </div>
                            )}
                          </div>
                        ))}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div flush>
          <div>
            <div>
              <span className="d-flex align-items-center gap-2">
                <h7>
                  <b>Self Care Assessment</b>
                </h7>
                {
                  <CFormLabel
                    className="patient-note-action d-flex mt-2 flex-column align-items-center justify-content-center shadow"
                    onClick={() => setVisible((p) => !p)}
                    style={{
                      width: '30px',
                      height: '30px',
                      borderRadius: '20px',
                      cursor: 'pointer',
                    }}
                  >
                    <Plus className="patient-note-action-icon" strokeWidth={2} size={15} />
                  </CFormLabel>
                }
              </span>
              <hr />
            </div>
            <div>
              <div>
                {
                  <div className="d-flex flex-column border rounded p-3 bg-light bg-secondary">
                    {noteStructureRef.current &&
                      noteStructureRef.current.selfCareAssessment &&
                      noteStructureRef.current.selfCareAssessment[diagnosisName] &&
                      Object.entries(noteStructureRef.current.selfCareAssessment[diagnosisName])
                        .filter(([_, value]) => {
                          if (value === null || value === undefined) return false
                          if (typeof value === 'string') return value.trim() !== ''
                          if (Array.isArray(value)) return value.length > 0
                          if (typeof value === 'object') {
                            const entries = Object.entries(value).filter(([_, v]) => v && (!Array.isArray(v) || v.length > 0) && (typeof v !== 'string' || v.trim() !== ''))
                            return entries.length > 0
                          }
                          return true
                        })
                        .map(([key, value], idx) => (
                          <div key={idx} className="d-flex flex-column mb-2">
                            {typeof value === 'object' && value !== null && !Array.isArray(value) ? (
                              (() => {
                                const rendered = renderValue(value, key)
                                return rendered ? (
                                  <>
                                    <b>{key}</b>
                                    <div>{rendered}</div>
                                  </>
                                ) : null
                              })()
                            ) : (
                              <div className="d-flex ">
                                <span>
                                  <b style={{ textTransform: 'capitalize' }}>{key}:</b>
                                  {Array.isArray(value) ? value.join(', ') : renderValue(value, key)}
                                </span>
                                <span></span>
                              </div>
                            )}
                          </div>
                        ))}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      )}
      <CModal className="patient-theme-modal patient-note-form-modal medication-theme__modal" backdrop="static" alignment="center" visible={visible} size="lg" onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>Self Care Assessment</CModalTitle>
        </CModalHeader>
        <CModalBody  >
      

                    <div className="px-4 py-3" style={{ height: 500, overflowY: 'auto' , overflowX: "hidden"}}>

          
          {/* <CFormInput
                        onChange={(e) => {

                            const today = new Date(e.target.value);
                            const formattedDate = `${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}-${today.getFullYear()}`;
                            handleChange('date', formattedDate);
                        }}
                        type='date' className='w-25' /> */}
          <div style={{ width: '30%' }}>
            <CustomDatePickingFormat
              value={selfCareValues.date}
              onChange={(e) => {
                handleChange('date', e)
              }}
            />
          </div>
          {/* BASIC CARE FIELDS */}
          {Object.keys(activityOptions).map((label) => (
            <div key={label}>
              <CFormLabel className="mt-2">{label}</CFormLabel>
              <Select
                {...selfCareSelectProps}
                isMulti
                options={sharedOptions.map((opt) => ({ value: opt, label: opt }))}
                value={(selfCareValues[label] || []).map((val) => ({ value: val, label: val }))}
                onChange={(selected) =>
                  handleChange(
                    label,
                    selected.map((s) => s.value),
                  )
                }
              />
            </div>
          ))}

          {/* VISION/HEARING */}
          <div>
            <CFormLabel className="mt-2">VISION/HEARING: MDS B</CFormLabel>
            <hr className="mt-0" />
            {/* <CFormInput
                            type="date"
                            className='w-25 mb-2'
                            onChange={(e) => {
                                const selectedDate = new Date(e.target.value);

                                const today = new Date(e.target.value);
                                const formattedDate = `${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}-${today.getFullYear()}`;
                                handleChange('date', formattedDate, "VISION/HEARING: MDS B (hearing, speech, vision)")    
                            }}
                        /> */}
            <CustomDatePickingFormat
              value={selfCareValues['VISION/HEARING: MDS B (hearing, speech, vision)']?.date}
              onChange={(e) => {
                handleChange('date', e, 'VISION/HEARING: MDS B (hearing, speech, vision)')
              }}
            />

            <div className="mt-2">
              <CFormLabel className="mt-2">Hearing Aid</CFormLabel>
              <Select
                {...selfCareSelectProps}
                placeholder="Select..."
                options={['Yes', 'No'].map((opt) => ({ value: opt, label: opt }))}
                value={getSingleSelectValue(selfCareValues['VISION/HEARING: MDS B (hearing, speech, vision)']['Hearing Aid'])}
                onChange={(selected) => handleChange('Hearing Aid', selected?.value ?? '', 'VISION/HEARING: MDS B (hearing, speech, vision)')}
              />
            </div>
            <CFormLabel className="mt-2">Vision</CFormLabel>
            <Select
              {...selfCareSelectProps}
              isMulti
              options={['Contacts', 'Glasses', 'None'].map((opt) => ({
                value: opt,
                label: opt,
              }))}
              value={(selfCareValues?.['VISION/HEARING: MDS B (hearing, speech, vision)']?.['Vision'] || []).filter((val) => typeof val === 'string' && val.trim() !== '').map((val) => ({ value: val, label: val }))}
              onChange={(selectedOptions) =>
                handleChange(
                  'Vision',
                  selectedOptions.map((s) => s.value),
                  'VISION/HEARING: MDS B (hearing, speech, vision)',
                )
              }
            />
          </div>

          <div>
            <CFormLabel className="mt-2">I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)</CFormLabel>
            <hr />

            {/* <CFormInput
                            type="date"
                            className="w-25 mb-2"
                            // onChange={e => handleChange('date', e.target.value, "I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)")}
                            onChange={(e) => {

                                const today = new Date(e.target.value);
                                const formattedDate = `${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}-${today.getFullYear()}`;
                                handleChange('date', formattedDate, "I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)");
                            }}

                        /> */}
            <div>
              <CustomDatePickingFormat
                value={selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)']?.date}
                onChange={(e) => {
                  handleChange('date', e, 'VISION/HEARING: MDS B (hearing, speech, vision)')
                }}
              />
            </div>

            <div className="mt-2">
              <CFormLabel className="mt-2">Diet</CFormLabel>
              <Select
                {...selfCareSelectProps}
                isMulti
                options={['Oral diet', 'Enteral ( G tube)', 'TPN (IV)'].map((opt) => ({ value: opt, label: opt }))}
                value={(selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)'].Diet || []).map((val) => ({ value: val, label: val }))}
                onChange={(selected) =>
                  handleChange(
                    'Diet',
                    selected.map((s) => s.value),
                    'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)',
                  )
                }
              />
            </div>

            <CFormLabel className="mt-2">Fluid</CFormLabel>
            <Select
              {...selfCareSelectProps}
              placeholder="Select..."
              options={['Restriction', 'No restriction'].map((opt) => ({ value: opt, label: opt }))}
              value={getSingleSelectValue(selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)'].Fluid)}
              onChange={(selected) => handleChange('Fluid', selected?.value ?? '', 'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)')}
            />

            <CFormLabel className="mt-2">Swallowing Issues</CFormLabel>
            <Select
              {...selfCareSelectProps}
              isMulti
              options={['No', 'Coughing or choking, Holding food in mouth or cheeks', 'Loss of liquids or solids from mouth when eating or drinking'].map((opt) => ({ value: opt, label: opt }))}
              value={(selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)']['Swallowing Issues'] || []).map((val) => ({ value: val, label: val }))}
              onChange={(selected) =>
                handleChange(
                  'Swallowing Issues',
                  selected.map((s) => s.value),
                  'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)',
                )
              }
            />

            <CFormLabel className="mt-2">Bowel Continence</CFormLabel>
            <Select
              {...selfCareSelectProps}
              isMulti
              options={['Always continent', 'Occasional incontinent', 'Frequently incontinent', 'Always incontinent'].map((opt) => ({ value: opt, label: opt }))}
              value={(selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)']['Bowel Continence'] || []).map((val) => ({ value: val, label: val }))}
              onChange={(selected) =>
                handleChange(
                  'Bowel Continence',
                  selected.map((s) => s.value),
                  'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)',
                )
              }
            />

            <CFormLabel className="mt-2">Bladder Continence</CFormLabel>
            <Select
              {...selfCareSelectProps}
              isMulti
              options={['Always continent', 'Occasional incontinent', 'Frequently incontinent', 'Always incontinent'].map((opt) => ({ value: opt, label: opt }))}
              value={(selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)']['Bladder Continence'] || []).map((val) => ({ value: val, label: val }))}
              onChange={(selected) =>
                handleChange(
                  'Bladder Continence',
                  selected.map((s) => s.value),
                  'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)',
                )
              }
            />
          </div>

          {/* FOUNDATIONAL GOALS */}
          <div>
            <CFormLabel className="mt-2">FOUNDATIONAL GOALS</CFormLabel>
            <hr className="mt-0" />
            {/* <CFormInput
                            type="date"
                            className='w-25 mb-2'
                            onChange={(e) => {
                                const today = new Date(e.target.value);
                                const formattedDate = `${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}-${today.getFullYear()}`;
                                handleChange('date', formattedDate, "Foundation Goals");
                            }}

                        /> */}
            <div className="mb-2">
              <CustomDatePickingFormat
                value={selfCareValues['Foundation Goals']?.date}
                onChange={(e) => {
                  handleChange('date', e, 'Foundation Goals')
                }}
              />
            </div>

            <CFormLabel className="mt-2">Patient meeting hydration goals</CFormLabel>
            <Select
              {...selfCareSelectProps}
              placeholder="Select..."
              options={['Yes', 'No'].map((opt) => ({ value: opt, label: opt }))}
              value={getSingleSelectValue(selfCareValues['Foundation Goals']['Patient meeting hydration goals'])}
              onChange={(selected) => handleChange('Patient meeting hydration goals', selected?.value ?? '', 'Foundation Goals')}
            />
            <CFormLabel className="mt-2">Patient meeting nutritional goals</CFormLabel>
            <Select
              {...selfCareSelectProps}
              placeholder="Select..."
              options={['Yes', 'No'].map((opt) => ({ value: opt, label: opt }))}
              value={getSingleSelectValue(selfCareValues['Foundation Goals']['Patient meeting nutritional goals'])}
              onChange={(selected) => handleChange('Patient meeting nutritional goals', selected?.value ?? '', 'Foundation Goals')}
            />
            <CFormLabel className="mt-2">Patient has 7-8 hours of uniterupted sleep?</CFormLabel>
            <Select
              {...selfCareSelectProps}
              placeholder="Select..."
              options={['Yes', 'No'].map((opt) => ({ value: opt, label: opt }))}
              value={getSingleSelectValue(selfCareValues['Foundation Goals']['Patient has 7-8 hours of uniterupted sleep?'])}
              onChange={(selected) => handleChange('Patient has 7-8 hours of uniterupted sleep?', selected?.value ?? '', 'Foundation Goals')}
            />
            <CFormLabel className="mt-2">Active Therapy</CFormLabel>

        
                     <Select
              {...selfCareSelectProps}
              isMulti
              options={['PT', 'OT', 'ST', 'Restorative'].map((opt) => ({ value: opt, label: opt }))}
              value={(selfCareValues['Foundation Goals']['Active Therapy'] || []).map((val) => ({
                value: val,
                label: val,
              }))}
              onChange={(selected) =>
                handleChange(
                  'Active Therapy',
                  selected.map((s) => s.value),
                  'Foundation Goals',
                )
              }
 
            />


            </div>
     
      
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
          <CButton color="primary" onClick={handleSave}>
            Save
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default SelfCareAssessment





// import React, { useEffect, useState } from 'react'
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   IconButton,
//   Divider,
//   Box,
//   Paper,
//   FormLabel,
//   TextField
// } from '@mui/material'
// import AddIcon from '@mui/icons-material/Add'
// import Select from 'react-select'
// import CustomDatePickingFormat from '../../../src/components/shared/CustomDatePickingFormat'
// import { BorderBottom } from '@mui/icons-material'

// const SelfCareAssessment = ({ 
//   diagnosisName, 
//   noteStructureRef, 
//   showDataIfNoteIsFollowUp = false, 
//   showTreatmentAsAccordion 
// }) => {
//   console.log(showDataIfNoteIsFollowUp, 'showDataIfNoteIsFollowUp in self care assessment')
//   const [visible, setVisible] = useState(false)
//   const today = new Date()
//   const formattedDate = `${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}/${today.getFullYear()}`

//   const [selfCareValues, setSelfCareValues] = useState({
//     date: formattedDate,
//     Eating: [],
//     'Oral hygiene': [],
//     'Toileting hygiene': [],
//     'Shower or bath': [],
//     'Upper body dressing': [],
//     'Lower body dressing': [],
//     'Putting on or taking off footwear': [],
//     'VISION/HEARING: MDS B (hearing, speech, vision)': {
//       date: formattedDate,
//       'Hearing Aid': '',
//       Vision: [],
//     },
//     'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)': {
//       date: formattedDate,
//       Diet: [],
//       Fluid: [],
//       'Swallowing Issues': [],
//       'Bowel Continence': [],
//       'Bladder Continence': [],
//     },
//     'Foundation Goals': {
//       date: formattedDate,
//       'Patient meeting hydration goals': '',
//       'Patient meeting nutritional goals': '',
//       'Patient has 7-8 hours of uniterupted sleep?': '',
//       'Active Therapy': [],
//     },
//   })

//   useEffect(() => {
//     if (noteStructureRef?.current?.selfCareAssessment && noteStructureRef.current.selfCareAssessment[diagnosisName]) {
//       setSelfCareValues(noteStructureRef.current.selfCareAssessment[diagnosisName])
//     }
//   }, [diagnosisName, noteStructureRef])

//   const handleChange = (key, value, section = null) => {
//     if (section) {
//       setSelfCareValues((prev) => ({
//         ...prev,
//         [section]: {
//           ...prev[section],
//           [key]: value,
//         },
//       }))
//     } else {
//       setSelfCareValues((prev) => ({
//         ...prev,
//         [key]: value,
//       }))
//     }
//   }

//   const activityOptions = {
//     Eating: 'Eating',
//     'Oral hygiene': 'Oral hygiene',
//     'Toileting hygiene': 'Toileting hygiene',
//     'Shower or bath': 'Shower or bath',
//     'Upper body dressing': 'Upper body dressing',
//     'Lower body dressing': 'Lower body dressing',
//     'Putting on or taking off footwear': 'Putting on or taking off footwear',
//   }

//   const sharedOptions = ['Independent', 'Set up or cleanup assistance', 'Supervision or touching assistant', 'Partial moderate assistant', 'Substantial maximal assistant', 'Dependent', 'Patient refused']

//   const handleSave = () => {
//     noteStructureRef.current = {
//       ...noteStructureRef.current,
//       selfCareAssessment: {
//         [diagnosisName]: selfCareValues,
//       },
//       assessment: {
//         ...noteStructureRef.current.assessment,
//         [diagnosisName]: {
//           ...noteStructureRef.current.assessment[diagnosisName],
//           selfCareAssessment: selfCareValues,
//         },
//       },
//     }
//     setVisible(false)
//     console.log(noteStructureRef)
//   }

//   const renderValue = (value, key) => {
//     if (!value || (Array.isArray(value) && value.length === 0)) {
//       return null
//     }

//     if (Array.isArray(value)) {
//       return value.join(', ')
//     } else if (typeof value === 'string') {
//       if (value.trim() === '') return null

//       // Format date if it looks like MM-DD-YYYY or MM/DD/YYYY
//       if (key.toLowerCase().includes('date')) {
//         const dateParts = value.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/)
//         if (dateParts) {
//           const [_, month, day, year] = dateParts
//           return `${month}/${day}/${year}`
//         }
//       }

//       return value
//     } else if (typeof value === 'object' && value !== null) {
//       const entries = Object.entries(value).filter(([childKey, childValue]) => {
//         const isEmpty = !childValue || (Array.isArray(childValue) && childValue.length === 0) || (typeof childValue === 'string' && childValue.trim() === '')
//         return !isEmpty
//       })

//       if (entries.length === 0) return null

//       return (
//         <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//           {entries.map(([childKey, childValue], idx) => {
//             const rendered = renderValue(childValue, childKey)
//             if (!rendered) return null
//             return (
//               <Box key={idx} sx={{ display: 'flex', gap: 1 }}>
//                 <b style={{ textTransform: 'capitalize' }}>{childKey}:</b>
//                 <span>{rendered}</span>
//               </Box>
//             )
//           })}
//         </Box>
//       )
//     }

//     return ''
//   }

//   return (
//     <>
//       {showTreatmentAsAccordion ? (
//         <Box flush >
//           <Box>
//             <Box>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Typography variant="body1" fontWeight="bold">
//                   Self Care Assessment
//                 </Typography>
//               </Box>
//               <Divider sx={{ my: 1 }} />
//             </Box>
//             <Box>
//               <Box>
//                 {
//                   <Box sx={{ display: 'flex', flexDirection: 'column', px: 2 }}>
//                     {noteStructureRef.current &&
//                       noteStructureRef.current.selfCareAssessment &&
//                       noteStructureRef.current.selfCareAssessment[diagnosisName] &&
//                       Object.entries(noteStructureRef.current.selfCareAssessment[diagnosisName])
//                         .filter(([_, value]) => {
//                           if (value === null || value === undefined) return false
//                           if (typeof value === 'string') return value.trim() !== ''
//                           if (Array.isArray(value)) return value.length > 0
//                           if (typeof value === 'object') {
//                             const entries = Object.entries(value).filter(([_, v]) => v && (!Array.isArray(v) || v.length > 0) && (typeof v !== 'string' || v.trim() !== ''))
//                             return entries.length > 0
//                           }
//                           return true
//                         })
//                         .map(([key, value], idx) => (
//                           <Box key={idx} sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
//                             {typeof value === 'object' && value !== null && !Array.isArray(value) ? (
//                               (() => {
//                                 const rendered = renderValue(value, key)
//                                 return rendered ? (
//                                   <>
//                                     <Typography variant="body2" fontWeight="bold">{key}</Typography>
//                                     <Box>{rendered}</Box>
//                                   </>
//                                 ) : null
//                               })()
//                             ) : (
//                               <Box sx={{ display: 'flex', gap: 1 }}>
//                                 <b style={{ textTransform: 'capitalize' }}>{key}:</b>
//                                 <span>{Array.isArray(value) ? value.join(', ') : renderValue(value, key)}</span>
//                               </Box>
//                             )}
//                           </Box>
//                         ))}
//                   </Box>
//                 }
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//       ) : (
//         <Box flush>
//           <Box >
//             <Box>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Typography variant="body1" fontWeight="bold">
//                   Self Care Assessment
//                 </Typography>
//                 <IconButton
//                   onClick={() => setVisible(true)}
//                   size="small"
//                   sx={{
//                     width: 30,
//                     height: 30,
//                     borderRadius: '20px',
//                     background: '#7B8BE7',
//                     '&:hover': { background: '#6a79d6' }
//                   }}
//                 >
//                   <AddIcon sx={{ color: '#fff', fontSize: 15 }} />
//                 </IconButton>
//               </Box>
//               <Divider sx={{ my: 1 }} />
//             </Box>
//             <Box>
//               <Box>
//                 {
//                   <Paper sx={{ p: 2, borderRadius: 2, bgcolor: '#f5f5f5' }}>
//                     {noteStructureRef.current &&
//                       noteStructureRef.current.selfCareAssessment &&
//                       noteStructureRef.current.selfCareAssessment[diagnosisName] &&
//                       Object.entries(noteStructureRef.current.selfCareAssessment[diagnosisName])
//                         .filter(([_, value]) => {
//                           if (value === null || value === undefined) return false
//                           if (typeof value === 'string') return value.trim() !== ''
//                           if (Array.isArray(value)) return value.length > 0
//                           if (typeof value === 'object') {
//                             const entries = Object.entries(value).filter(([_, v]) => v && (!Array.isArray(v) || v.length > 0) && (typeof v !== 'string' || v.trim() !== ''))
//                             return entries.length > 0
//                           }
//                           return true
//                         })
//                         .map(([key, value], idx) => (
//                           <Box key={idx} sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
//                             {typeof value === 'object' && value !== null && !Array.isArray(value) ? (
//                               (() => {
//                                 const rendered = renderValue(value, key)
//                                 return rendered ? (
//                                   <>
//                                     <Typography variant="body2" fontWeight="bold">{key}</Typography>
//                                     <Box>{rendered}</Box>
//                                   </>
//                                 ) : null
//                               })()
//                             ) : (
//                               <Box sx={{ display: 'flex' }}>
//                                 <Typography variant="body2">
//                                   <b style={{ textTransform: 'capitalize' }}>{key}:</b>
//                                   {Array.isArray(value) ? value.join(', ') : renderValue(value, key)}
//                                 </Typography>
//                               </Box>
//                             )}
//                           </Box>
//                         ))}
//                   </Paper>
//                 }
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//       )}
      
//       <Dialog open={visible} onClose={() => setVisible(false)} fullWidth maxWidth="lg"   PaperProps={{
//     sx: {
//       borderRadius: '20px',
//       width: 800
//     }
//   }} >
//         <DialogTitle  sx={{  borderBottom: "1px solid lightGray", fontWeight: 400 }}>Self Care Assessment</DialogTitle>
//         <DialogContent sx={{ height: '500px', overflowY: 'auto' }}>
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//             {/* Date */}
//             <Box sx={{ width: '30%' , marginTop: 2}}>
//               <CustomDatePickingFormat
//                 value={selfCareValues.date}
//                 onChange={(e) => {
//                   handleChange('date', e)
//                 }}
//               />
//             </Box>
            
//             {/* BASIC CARE FIELDS */}
//             {Object.keys(activityOptions).map((label) => (
//               <Box key={label}>
//                 <FormLabel sx={{ mt: 2, display: 'block' }}>{label}</FormLabel>
//                 <Select
//                   isMulti
//                   options={sharedOptions.map((opt) => ({ value: opt, label: opt }))}
//                   value={(selfCareValues[label] || []).map((val) => ({ value: val, label: val }))}
//                   onChange={(selected) =>
//                     handleChange(
//                       label,
//                       selected.map((s) => s.value),
//                     )
//                   }
//                 />
//               </Box>
//             ))}

//             {/* VISION/HEARING */}
//             <Box>
//               <FormLabel sx={{ mt: 2, display: 'block',borderBottom: "1px solid lightGray" , marginBottom: 2 }}>VISION/HEARING: MDS B</FormLabel>
//               {/* <Divider sx={{ my: 1 }} /> */}
              
//               <CustomDatePickingFormat
              
//                 value={selfCareValues['VISION/HEARING: MDS B (hearing, speech, vision)']?.date}
//                 onChange={(e) => {
//                   handleChange('date', e, 'VISION/HEARING: MDS B (hearing, speech, vision)')
//                 }}
//               />

//               <Box sx={{ mt: 2 }}>
//                 <FormLabel sx={{ mt: 2, display: 'block' }}>Hearing Aid</FormLabel>
//                 <Select
//                   options={['Yes', 'No'].map((opt) => ({ value: opt, label: opt }))}
//                   value={{ value: selfCareValues['VISION/HEARING: MDS B (hearing, speech, vision)']['Hearing Aid'], label: selfCareValues['VISION/HEARING: MDS B (hearing, speech, vision)']['Hearing Aid'] }}
//                   onChange={(selected) => handleChange('Hearing Aid', selected.value, 'VISION/HEARING: MDS B (hearing, speech, vision)')}
//                 />
//               </Box>
              
//               <FormLabel sx={{ mt: 2, display: 'block' }}>Vision</FormLabel>
//               <Select
//                 isMulti
//                 options={['Contacts', 'Glasses', 'None'].map((opt) => ({
//                   value: opt,
//                   label: opt,
//                 }))}
//                 value={(selfCareValues?.['VISION/HEARING: MDS B (hearing, speech, vision)']?.['Vision'] || []).filter((val) => typeof val === 'string' && val.trim() !== '').map((val) => ({ value: val, label: val }))}
//                 onChange={(selectedOptions) =>
//                   handleChange(
//                     'Vision',
//                     selectedOptions.map((s) => s.value),
//                     'VISION/HEARING: MDS B (hearing, speech, vision)',
//                   )
//                 }
//               />
//             </Box>

//             {/* I/O SECTION */}
//             <Box>
//               <FormLabel sx={{ mt: 2, display: 'block', borderBottom: "1px solid lightGray" , marginBottom: 2 }}>I/O: MDS section K (swallowing/nutrition) And Section H (bowel/bladder)</FormLabel>
//               <Divider sx={{ my: 1 }} />

//               <CustomDatePickingFormat
//                 value={selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)']?.date}
//                 onChange={(e) => {
//                   handleChange('date', e, 'VISION/HEARING: MDS B (hearing, speech, vision)')
//                 }}
//               />

//               <Box sx={{ mt: 2 }}>
//                 <FormLabel sx={{ mt: 2, display: 'block' }}>Diet</FormLabel>
//                 <Select
//                   isMulti
//                   options={['Oral diet', 'Enteral ( G tube)', 'TPN (IV)'].map((opt) => ({ value: opt, label: opt }))}
//                   value={(selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)'].Diet || []).map((val) => ({ value: val, label: val }))}
//                   onChange={(selected) =>
//                     handleChange(
//                       'Diet',
//                       selected.map((s) => s.value),
//                       'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)',
//                     )
//                   }
//                 />
//               </Box>

//               <FormLabel sx={{ mt: 2, display: 'block' }}>Fluid</FormLabel>
//               <Select
//                 options={['Restriction', 'No restriction'].map((opt) => ({ value: opt, label: opt }))}
//                 value={{
//                   value: selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)'].Fluid,
//                   label: selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)'].Fluid,
//                 }}
//                 onChange={(selected) => handleChange('Fluid', selected.value, 'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)')}
//               />

//               <FormLabel sx={{ mt: 2, display: 'block' }}>Swallowing Issues</FormLabel>
//               <Select
//                 isMulti
//                 options={['No', 'Coughing or choking, Holding food in mouth or cheeks', 'Loss of liquids or solids from mouth when eating or drinking'].map((opt) => ({ value: opt, label: opt }))}
//                 value={(selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)']['Swallowing Issues'] || []).map((val) => ({ value: val, label: val }))}
//                 onChange={(selected) =>
//                   handleChange(
//                     'Swallowing Issues',
//                     selected.map((s) => s.value),
//                     'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)',
//                   )
//                 }
//               />

//               <FormLabel sx={{ mt: 2, display: 'block' }}>Bowel Continence</FormLabel>
//               <Select
//                 isMulti
//                 options={['Always continent', 'Occasional incontinent', 'Frequently incontinent', 'Always incontinent'].map((opt) => ({ value: opt, label: opt }))}
//                 value={(selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)']['Bowel Continence'] || []).map((val) => ({ value: val, label: val }))}
//                 onChange={(selected) =>
//                   handleChange(
//                     'Bowel Continence',
//                     selected.map((s) => s.value),
//                     'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)',
//                   )
//                 }
//               />

//               <FormLabel sx={{ mt: 2, display: 'block' }}>Bladder Continence</FormLabel>
//               <Select
//                 isMulti
//                 options={['Always continent', 'Occasional incontinent', 'Frequently incontinent', 'Always incontinent'].map((opt) => ({ value: opt, label: opt }))}
//                 value={(selfCareValues['I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)']['Bladder Continence'] || []).map((val) => ({ value: val, label: val }))}
//                 onChange={(selected) =>
//                   handleChange(
//                     'Bladder Continence',
//                     selected.map((s) => s.value),
//                     'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)',
//                   )
//                 }
//               />
//             </Box>

//             {/* FOUNDATIONAL GOALS */}
//             <Box>
//               <FormLabel sx={{ mt: 2, display: 'block', fontWeight: 'bold' }}>FOUNDATIONAL GOALS</FormLabel>
//               <Divider sx={{ my: 1 }} />
              
//               <Box sx={{ mb: 2 }}>
//                 <CustomDatePickingFormat
//                   value={selfCareValues['Foundation Goals']?.date}
//                   onChange={(e) => {
//                     handleChange('date', e, 'Foundation Goals')
//                   }}
//                 />
//               </Box>

//               <FormLabel sx={{ mt: 2, display: 'block' }}>Patient meeting hydration goals</FormLabel>
//               <Select
//                 options={['Yes', 'No'].map((opt) => ({ value: opt, label: opt }))}
//                 value={{ value: selfCareValues['Foundation Goals']['Patient meeting hydration goals'], label: selfCareValues['Foundation Goals']['Patient meeting hydration goals'] }}
//                 onChange={(selected) => handleChange('Patient meeting hydration goals', selected.value, 'Foundation Goals')}
//               />
              
//               <FormLabel sx={{ mt: 2, display: 'block' }}>Patient meeting nutritional goals</FormLabel>
//               <Select
//                 options={['Yes', 'No'].map((opt) => ({ value: opt, label: opt }))}
//                 value={{ value: selfCareValues['Foundation Goals']['Patient meeting nutritional goals'], label: selfCareValues['Foundation Goals']['Patient meeting nutritional goals'] }}
//                 onChange={(selected) => handleChange('Patient meeting nutritional goals', selected.value, 'Foundation Goals')}
//               />
              
//               <FormLabel sx={{ mt: 2, display: 'block' }}>Patient has 7-8 hours of uninterrupted sleep?</FormLabel>
//               <Select
//                 options={['Yes', 'No'].map((opt) => ({ value: opt, label: opt }))}
//                 value={{ value: selfCareValues['Foundation Goals']['Patient has 7-8 hours of uniterupted sleep?'], label: selfCareValues['Foundation Goals']['Patient has 7-8 hours of uniterupted sleep?'] }}
//                 onChange={(selected) => handleChange('Patient has 7-8 hours of uniterupted sleep?', selected.value, 'Foundation Goals')}
//               />
              
//               <FormLabel sx={{ mt: 2, display: 'block' }}>Active Therapy</FormLabel>
//               <Select
//                 isMulti
//                 options={['PT', 'OT', 'ST', 'Restorative'].map((opt) => ({ value: opt, label: opt }))}
//                 value={(selfCareValues['Foundation Goals']['Active Therapy'] || []).map((val) => ({
//                   value: val,
//                   label: val,
//                 }))}
//                 onChange={(selected) =>
//                   handleChange(
//                     'Active Therapy',
//                     selected.map((s) => s.value),
//                     'Foundation Goals',
//                   )
//                 }
//               />
//             </Box>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button variant="outlined" color="secondary" onClick={() => setVisible(false)}>
//             Close
//           </Button>
//           <Button variant="contained" color="primary" onClick={handleSave}>
//             Save changes
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   )
// }

// export default SelfCareAssessment








// import {
//   CButton, CModal, CModalBody, CModalFooter,
//   CModalHeader, CModalTitle, CFormLabel
// } from '@coreui/react'
// import { Plus } from 'lucide-react'
// import React, { useEffect, useState } from 'react'
// import Select from 'react-select'
// import CustomDatePickingFormat from '../../../src/components/shared/CustomDatePickingFormat'

// const sharedOptions = [
//   'Independent', 'Set up or cleanup assistance', 'Supervision or touching assistant',
//   'Partial moderate assistant', 'Substantial maximal assistant', 'Dependent', 'Patient refused'
// ].map(opt => ({ value: opt, label: opt }))

// const activityKeys = [
//   'Eating', 'Oral hygiene', 'Toileting hygiene', 'Shower or bath',
//   'Upper body dressing', 'Lower body dressing', 'Putting on or taking off footwear'
// ]

// const defaultState = () => {
//   const today = new Date()
//   const formattedDate = `${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}/${today.getFullYear()}`
//   return {
//     date: formattedDate,
//     Eating: [], 'Oral hygiene': [], 'Toileting hygiene': [], 'Shower or bath': [],
//     'Upper body dressing': [], 'Lower body dressing': [], 'Putting on or taking off footwear': [],
//     'VISION/HEARING: MDS B (hearing, speech, vision)': {
//       date: formattedDate, 'Hearing Aid': '', Vision: [],
//     },
//     'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)': {
//       date: formattedDate, Diet: [], Fluid: [], 'Swallowing Issues': [],
//       'Bowel Continence': [], 'Bladder Continence': [],
//     },
//     'Foundation Goals': {
//       date: formattedDate,
//       'Patient meeting hydration goals': '',
//       'Patient meeting nutritional goals': '',
//       'Patient has 7-8 hours of uniterupted sleep?': '',
//       'Active Therapy': [],
//     },
//   }
// }

// // Shared props to fix dropdown clipping inside scrollable modals
// // const selectPortalProps = {
// //   menuPortalTarget: document.body,
// //   menuPosition: 'fixed',
// //     menuPlacement: 'auto',  
// //   // styles: { menuPortal: base => ({ ...base, zIndex: 999999 }) },

// //     styles: {
// //     menuPortal: base => ({ ...base, zIndex: 999999 }),
// //     menu: base => ({
// //       ...base,
// //       zIndex: 999999,
      
// //     }),
// //     position: "absolute"
// //   },


// // }



// const SelfCareAssessment = ({ diagnosisName, noteStructureRef, showTreatmentAsAccordion }) => {
//   const [visible, setVisible] = useState(false)
//   const [selfCareValues, setSelfCareValues] = useState(defaultState)

//   useEffect(() => {
//     if (noteStructureRef?.current?.selfCareAssessment?.[diagnosisName]) {
//       setSelfCareValues(noteStructureRef.current.selfCareAssessment[diagnosisName])
//     }
//   }, [diagnosisName, noteStructureRef, visible])

//   const handleChange = (key, value, section = null) => {
//     setSelfCareValues(prev =>
//       section
//         ? { ...prev, [section]: { ...prev[section], [key]: value } }
//         : { ...prev, [key]: value }
//     )
//   }

//   const handleSave = () => {
//     noteStructureRef.current = {
//       ...noteStructureRef.current,
//       selfCareAssessment: { [diagnosisName]: selfCareValues },
//       assessment: {
//         ...noteStructureRef.current.assessment,
//         [diagnosisName]: {
//           ...noteStructureRef.current.assessment?.[diagnosisName],
//           selfCareAssessment: selfCareValues,
//         },
//       },
//     }
//     setVisible(false)
//   }

//   const renderValue = (value, key) => {
//     if (!value || (Array.isArray(value) && value.length === 0)) return null
//     if (Array.isArray(value)) return value.join(', ')
//     if (typeof value === 'string') {
//       if (value.trim() === '') return null
//       return value
//     }
//     if (typeof value === 'object') {
//       const entries = Object.entries(value).filter(([, v]) =>
//         v && !(Array.isArray(v) && v.length === 0) && !(typeof v === 'string' && v.trim() === '')
//       )
//       if (!entries.length) return null
//       return (
//         <div className="d-flex flex-column">
//           {entries.map(([k, v], i) => {
//             const rendered = renderValue(v, k)
//             return rendered ? (
//               <div key={i} className="d-flex gap-2">
//                 <b style={{ textTransform: 'capitalize' }}>{k}:</b>
//                 <span>{rendered}</span>
//               </div>
//             ) : null
//           })}
//         </div>
//       )
//     }
//     return ''
//   }

//   const displayData = noteStructureRef.current?.selfCareAssessment?.[diagnosisName]

//   const renderDisplay = () =>
//     displayData &&
//     Object.entries(displayData)
//       .filter(([, v]) => {
//         if (!v) return false
//         if (typeof v === 'string') return v.trim() !== ''
//         if (Array.isArray(v)) return v.length > 0
//         if (typeof v === 'object') {
//           return Object.values(v).some(
//             inner => inner && !(Array.isArray(inner) && inner.length === 0) && !(typeof inner === 'string' && inner.trim() === '')
//           )
//         }
//         return true
//       })
//       .map(([key, value], idx) => (
//         <div key={idx} className="d-flex flex-column mb-2">
//           {typeof value === 'object' && !Array.isArray(value) ? (
//             (() => {
//               const rendered = renderValue(value, key)
//               return rendered ? <><b>{key}</b><div>{rendered}</div></> : null
//             })()
//           ) : (
//             <div className="d-flex gap-2">
//               <b style={{ textTransform: 'capitalize' }}>{key}:</b>
//               <span>{Array.isArray(value) ? value.join(', ') : renderValue(value, key)}</span>
//             </div>
//           )}
//         </div>
//       ))

//   const VISION = 'VISION/HEARING: MDS B (hearing, speech, vision)'
//   const IO = 'I/O: MDS section K (swallowing/nutririon) And Section H (bowel/bladder)'
//   const FG = 'Foundation Goals'

//   return (
//     <>
//       <div className="d-flex align-items-center gap-2">
//         <b>Self Care Assessment</b>
//         {!showTreatmentAsAccordion && (
//           <CFormLabel
//             className="d-flex mt-2 flex-column align-items-center justify-content-center shadow"
//             onClick={() => setVisible(p => !p)}
//             style={{ width: 30, height: 30, borderRadius: 20, background: '#7B8BE7', cursor: 'pointer' }}
//           >
//             <Plus className="text-white" strokeWidth={2} size={15} />
//           </CFormLabel>
//         )}
//       </div>
//       <hr />

//       <div className={showTreatmentAsAccordion ? 'px-3' : 'border rounded p-3 bg-light'} style={{ fontSize: 14, color: '#2C384AF2' }}>
//         {renderDisplay()}
//       </div>

//       {/* ── Modal ── */}
//       <CModal  backdrop="static" 
//   size="lg" 
//   scrollable // This makes the Modal Body scrollable automatically
//   visible={visible} 
//   onClose={() => setVisible(false)}
//   contentClassName="selfcare-modal">


//         <CModalHeader>
//           <CModalTitle>Self Care Assessment</CModalTitle>
//         </CModalHeader>

//         {/* KEY FIX: overflow on inner div, NOT on CModalBody */}
//         <CModalBody>
//           <div className="px-4 py-3" style={{ height: 500, overflowY: 'auto' , overflowX: "hidden"}}>

//             {/* Date */}
//             <div className="mb-3" style={{ width: '40%' }}>
//               <CFormLabel className="fw-medium mb-0">Date</CFormLabel>
//               <CustomDatePickingFormat value={selfCareValues.date} onChange={v => handleChange('date', v)} />
//             </div>

//             {/* Basic care */}
//             {activityKeys.map(label => (
//               <div className="mb-3" key={label}>
//                 <CFormLabel className="fw-medium">{label}</CFormLabel>
//                 <Select
                
          
//                   isMulti
//                   options={sharedOptions}
//                   value={(selfCareValues[label] || []).map(val => ({ value: val, label: val }))}
//                   onChange={sel => handleChange(label, sel.map(s => s.value))}
//                 />
//               </div>
//             ))}

//             {/* Vision / Hearing */}
//             <div className="mb-3">
//               <CFormLabel className="fw-medium">VISION / HEARING: MDS B</CFormLabel>
//               <hr className="mt-0" />
//               <div style={{ width: '40%' }}>
//                 <CustomDatePickingFormat
//                   value={selfCareValues[VISION]?.date}
//                   onChange={v => handleChange('date', v, VISION)}
//                 />
//               </div>
//               <CFormLabel className="mt-2">Hearing Aid</CFormLabel>
//               <Select
  
//                 options={['Yes', 'No'].map(o => ({ value: o, label: o }))}
//                 value={{ value: selfCareValues[VISION]['Hearing Aid'], label: selfCareValues[VISION]['Hearing Aid'] }}
//                 onChange={sel => handleChange('Hearing Aid', sel.value, VISION)}
//               />
//               <CFormLabel className="mt-2">Vision</CFormLabel>
//               <Select

//                 isMulti
//                 options={['Contacts', 'Glasses', 'None'].map(o => ({ value: o, label: o }))}
//                 value={(selfCareValues[VISION]?.Vision || []).filter(v => typeof v === 'string' && v.trim()).map(v => ({ value: v, label: v }))}
//                 onChange={sel => handleChange('Vision', sel.map(s => s.value), VISION)}
//               />
//             </div>

//             {/* I/O */}
//             <div className="mb-3">
//               <CFormLabel className="fw-medium">I/O: MDS Section K & H</CFormLabel>
//               <hr className="mt-0" />
//               <div style={{ width: '40%' }}>
//                 <CustomDatePickingFormat
//                   value={selfCareValues[IO]?.date}
//                   onChange={v => handleChange('date', v, IO)}
//                 />
//               </div>
//               {[
//                 { label: 'Diet', opts: ['Oral diet', 'Enteral ( G tube)', 'TPN (IV)'], multi: true },
//                 { label: 'Fluid', opts: ['Restriction', 'No restriction'], multi: false },
//                 { label: 'Swallowing Issues', opts: ['No', 'Coughing or choking, Holding food in mouth or cheeks', 'Loss of liquids or solids from mouth when eating or drinking'], multi: true },
//                 { label: 'Bowel Continence', opts: ['Always continent', 'Occasional incontinent', 'Frequently incontinent', 'Always incontinent'], multi: true },
//                 { label: 'Bladder Continence', opts: ['Always continent', 'Occasional incontinent', 'Frequently incontinent', 'Always incontinent'], multi: true },
//               ].map(({ label, opts, multi }) => (
//                 <div key={label}>
//                   <CFormLabel className="mt-2">{label}</CFormLabel>
//                   <Select
          
//                     isMulti={multi}
//                     options={opts.map(o => ({ value: o, label: o }))}
//                     value={
//                       multi
//                         ? (selfCareValues[IO][label] || []).map(v => ({ value: v, label: v }))
//                         : { value: selfCareValues[IO][label], label: selfCareValues[IO][label] }
//                     }
//                     onChange={sel =>
//                       handleChange(label, multi ? sel.map(s => s.value) : sel.value, IO)
//                     }
//                   />
//                 </div>
//               ))}
//             </div>

//             {/* Foundation Goals */}
//             <div className="mb-3">
//               <CFormLabel className="fw-medium">FOUNDATIONAL GOALS</CFormLabel>
//               <hr className="mt-0" />
//               <div style={{ width: '40%' }}>
//                 <CustomDatePickingFormat
//                   value={selfCareValues[FG]?.date}
//                   onChange={v => handleChange('date', v, FG)}
//                 />
//               </div>
//               {[
//                 'Patient meeting hydration goals',
//                 'Patient meeting nutritional goals',
//                 'Patient has 7-8 hours of uniterupted sleep?',
//               ].map(label => (
//                 <div key={label}>
//                   <CFormLabel className="mt-2">{label}</CFormLabel>
//                   <Select
      
//                     options={['Yes', 'No'].map(o => ({ value: o, label: o }))}
//                     value={{ value: selfCareValues[FG][label], label: selfCareValues[FG][label] }}
//                     onChange={sel => handleChange(label, sel.value, FG)}
//                   />
//                 </div>
//               ))}
//               <CFormLabel className="mt-2">Active Therapy</CFormLabel>
//               <Select
               
//                 isMulti
//                 options={['PT', 'OT', 'ST', 'Restorative'].map(o => ({ value: o, label: o }))}
//                 value={(selfCareValues[FG]['Active Therapy'] || []).map(v => ({ value: v, label: v }))}
//                 onChange={sel => handleChange('Active Therapy', sel.map(s => s.value), FG)}
                
//               />
//             </div>

//           </div>
//         </CModalBody>

//         <CModalFooter style={{ borderTop: '1px solid #f1f1f1' }} className="py-2 px-4">
//           <CButton variant="outline" color="secondary" onClick={() => setVisible(false)}>Close</CButton>
//           <CButton variant="outline" color="primary" onClick={handleSave}>Save changes</CButton>
//         </CModalFooter>
//       </CModal>
//     </>
//   )
// }

// export default SelfCareAssessment
